import { render, staticRenderFns } from "./CardUncho.vue?vue&type=template&id=61167b59&scoped=true&"
import script from "./CardUncho.vue?vue&type=script&lang=js&"
export * from "./CardUncho.vue?vue&type=script&lang=js&"
import style0 from "./CardUncho.vue?vue&type=style&index=0&id=61167b59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61167b59",
  null
  
)

export default component.exports